<template>
        <div>
        <ui-modal ref="mileageLogEntryModal" title="Add Mileage Log Entry" @hide="$emit('hide')" class=" ui-modal--grey-footer" dismiss-on="close-button esc">
            <div class="container-fluid" style="padding: 0; margin-top: 1rem;">
                <div class="row" style="margin-bottom: 1rem;">
                    <div class="col-6">
                        <ui-datepicker :start-of-week="1" v-model="mileageLogEntry.date" label="Date" append-dropdown-to-body></ui-datepicker>
                    </div>
                    <div class="col-6">
                        <ui-textbox v-model="mileageLogEntry.miles" label="Mileage"></ui-textbox>
                    </div>
                    <div class="col-12">
                        <ui-textbox 
                            v-model="mileageLogEntry.notes" 
                            label="Notes" 
                            :multi-line="true" 
                            :maxlength="256" 
                            :enforce-max-length="true"
                        ></ui-textbox>
                    </div>
                    <div class="col-12">
                        <ui-switch
                            v-model="mileageLogEntry.add_service_entry"    
                            style="margin-bottom: 1rem;"
                        >Add service entry?</ui-switch>
                    </div>
                    <div v-if="mileageLogEntry.add_service_entry" class="col-12">
                        <ui-select
                            :options="['Interim', 'Full', 'Major']"
                            v-model="mileageLogEntry.service_type"    
                            style="margin-bottom: 1rem;"
                        >Service Type</ui-select>
                    </div>
                </div>
            </div>
            <div slot="footer" style="width: 100%; text-align: left;">
                <ui-button color="primary" @click="save" :loading="isLoading" :disabled="!isValidState">Save</ui-button>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    import { VehicleMileageLogSchema, VehicleMileageLogResource } from '../../../classes/Api/Vehicle';

    export default {
        props: {
            instance: {
                required: true
            }
        },
        computed: {
            isValidState() {
                return this.mileageLogEntry.miles && this.mileageLogEntry.miles > 0;
            }
        },
        data() {
            return {
                isLoading: false,
                mileageLogEntry: null,
                addServiceEntry: false,
                serviceType: '',
            }
        },
        created() {
            this.reset();
        },
        methods: {
            open(booking_id = null) {
                this.reset();

                this.mileageLogEntry.booking_id = booking_id;

                this.$refs['mileageLogEntryModal'].open();
            },
            close() {
                this.$refs['mileageLogEntryModal'].close();
            },
            reset() {
                this.isLoading = false;

                this.mileageLogEntry = new VehicleMileageLogSchema({
                    miles: null,
                    notes: null,
                    date: new Date(),
                    loading: false,
                    created_at: new Date(),
                    created_by: window.marque.ui.user,
                    add_service_entry: false,
                    service_type: '',
                });
            },
            save() {
                this.isLoading = true;

                if (this.isValidState) {
                    VehicleMileageLogResource
                        .forVehicle(this.instance.vehicle.id)
                        .storeOrUpdate(this.mileageLogEntry.id, this.mileageLogEntry, { with: ['serviceRecord'] })
                        .then((response) => {
                            this.close();
                            this.$emit('saved', response.data);
                        }, (error) => {
                            this.isLoading = false;
                            handleApiError(error);
                        });
                }
            },
        }
    }
</script>